module.exports = __webpack_public_path__ + "img/carpet_five.0529b47c.png";